import { Link } from "react-router-dom";
import type { Novel } from "@/types";
import { formatWordCount } from "@/utils/catalog";

interface NovelCardProps {
  novel: Novel;
}

export default function NovelCard({ novel }: NovelCardProps) {
  const finished = novel.status === "已完结";
  return (
    <Link
      to={`/detail/novel/${novel.id}`}
      className="group flex gap-3 md:gap-4 rounded-lg bg-background-50 border border-background-200 p-3 hover:border-primary-300 transition-all cursor-pointer"
    >
      <div className="relative w-20 md:w-24 shrink-0 aspect-[2/3] rounded-md overflow-hidden bg-background-200">
        <img
          src={novel.cover}
          alt={novel.title}
          title={`${novel.title} - 小说封面`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
            {novel.title}
          </h3>
          <span
            className={`shrink-0 px-2 py-0.5 rounded-full text-xs font-label font-medium ${
              finished
                ? "bg-secondary-100 text-secondary-800"
                : "bg-accent-100 text-accent-800"
            }`}
          >
            {novel.status}
          </span>
        </div>
        <p className="mt-1 text-xs text-foreground-500">
          {novel.author} · {novel.genre} · {formatWordCount(novel.wordCount)}
        </p>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {novel.summary}
        </p>
        <div className="mt-auto pt-2 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-thumb-up-line text-primary-500"></i>
            {novel.recommend}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-list-ordered text-primary-500"></i>
            {novel.chapters.length} 章预览
          </span>
        </div>
      </div>
    </Link>
  );
}